import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { LivenessWebVerifyStatusEnum } from "@funded-here-interface/common/src/constant/enum";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import axios from "axios";

interface LivenessPhotoVideoRequest {
  token: string;
  clientSessionId: string;
  sessionId: string;
  userId: string;
  livenessStatus: LivenessWebVerifyStatusEnum;
  confidence: number;
  dataToView: string;
}

const getLivenessPhotoVideo = async ({
  token,
  clientSessionId,
  sessionId,
  userId,
  livenessStatus,
  confidence,
  dataToView,
}: LivenessPhotoVideoRequest) => {
  try {
    let url = `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/users/liveness-photo-video`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        clientSessionId,
        sessionId,
        userId,
        livenessStatus,
        confidence,
        dataToView,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    (e as Error).message = message;
    throw e;
  }
};

export default getLivenessPhotoVideo;
